import { render, staticRenderFns } from "./suData.vue?vue&type=template&id=9f3f2684&scoped=true&"
import script from "./suData.vue?vue&type=script&lang=js&"
export * from "./suData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3f2684",
  null
  
)

export default component.exports